'use strict';

wbApp.controller('ActionsScheduleCtrl', ['$scope', '$modal', '$translate','courseScheduleSvc',
function ($scope, $modal, $translate, courseScheduleSvc) {

    var selectedAction = null;
    var isActive = false;
    var loaded = false;
    $scope.canAddNewRow = false;
    $scope.actionSchedules = [];

    function setCanAddNewRow() {
        if ($scope.actionSchedules.$promise) {
            $scope.actionSchedules.$promise.then(function () {
                if ($scope.actionSchedules.length === 0) {
                    $scope.canAddNewRow = true;
                } else {
                    $scope.canAddNewRow = false;
                }
            });
        } else {
            $scope.canAddNewRow = false;
        }
    }

    $scope.$on('selectedActionChanged', function (e, actionInd) {
        if (actionInd.action) {
            if (isActive) {
                if (selectedAction !== actionInd.action || actionInd.refresh) {
                    $scope.actionSchedules = courseScheduleSvc.getAllAsync(actionInd.action.courseID, true /*actionInd.refresh*/);
                    setCanAddNewRow();
                }
                loaded = true;
            } else {
                loaded = false;
            }
        } else {
            $scope.actionSchedules.length = 0;
        }
        selectedAction = actionInd.action;
    });

    $scope.$on('activeTabChanged', function (e, data) {
        if (data.activeTab === 2) {
            if (!isActive) {
                isActive = true;
                if (!loaded && selectedAction) {
                    $scope.actionSchedules = courseScheduleSvc.getAllAsync(selectedAction.courseID, true);
                    setCanAddNewRow();
                    loaded = true;
                }
            }
        } else {
            isActive = false;
        }
    });

    $scope.gridSettings = {
        columns: [
            { dataField: 'startDate', caption: $translate.instant('TXT_LBL_START_DATE'), dataType: 'date', format: { raw: "dd.MM.yy EEE HH:mm" }, width: '150px', sortOrder: 'asc' },
            { dataField: 'endDate', caption: $translate.instant('TXT_LBL_END_DATE'), dataType: 'date', format: { raw: "HH:mm" }, width: '60px' },
            { dataField: 'classroomName', caption: $translate.instant('TXT_LBL_CLASSROOM'), dataType: 'string', width: '180px' },
            {
                dataField: 'teacher',
                caption: $translate.instant('TXT_LBL_EMPLOYEE'),
                dataType: 'string',
                width: '170px',
                calculateDisplayValue: function (rowData) {
                    let numberOfTeachers = rowData.teacherIds.split(',').length;
                    if (numberOfTeachers > 1) {
                        return `${rowData.teacher} (+${numberOfTeachers - 1})`;
                    }
                    return rowData.teacher;
                },
            },
            { dataField: 'filled', caption: $translate.instant('TXT_LBL_FILLED'), dataType: 'number', width: '70px' },
            { dataField: 'notes', caption: $translate.instant('TXT_NOTE'), dataType: 'string' }
        ],
        shouldDisableAdd: function () { return !$scope.selectedAction || !$scope.canAddNewRow }
    }
    
    $scope.selectedSchedule = {};

    $scope.onRowSelected = function (data) {
        $scope.selectedSchedule = data;
    }

    $scope.onRowEdit = function (data) {
        eventDetailDialogPromise.$promise.then(function () {
            eventDetailDialogPromise.$scope.model = angular.copy(data);
            eventDetailDialogPromise.$scope.hideActionChange = true;
            eventDetailDialogPromise.$scope.onSave = $scope.onActionScheduleChanged;
            eventDetailDialogPromise.show();
        });
    }

    $scope.onRowAdd = function () {
        if ($scope.canAddNewRow) {
            eventDetailDialogPromise.$promise.then(function () {
                eventDetailDialogPromise.$scope.model = courseScheduleSvc.createNew(selectedAction);
                eventDetailDialogPromise.$scope.hideActionChange = true;
                eventDetailDialogPromise.$scope.onSave = $scope.onActionScheduleChanged;
                eventDetailDialogPromise.show();
            });
        }
    }

    $scope.onRowDelete = function (data) {
        courseScheduleSvc.remove(data, { sendEmailNotification: true, sendSmsNotification: false }, function () {
            $scope.onActionScheduleChanged(data);
        });
        setCanAddNewRow();
    }

    $scope.onActionScheduleChanged = function (model) {
        $scope.$emit('onActionShouldRefresh', { action: $scope.selectedAction });
    }

    //var detailDialogPromise = $modal({
    //    templateUrl: 'actions/actions/actions-detail-tabs/schedule-detail.html',
    //    show: false,
    //    scope: $scope.$new()
    //});

    var eventDetailDialogPromise = $modal({
        templateUrl: 'schedule/schedule-event-detail.html',
        show: false,
        scope: $scope.$new()
    });
}]);
